import { render } from "./TransformacionDigitalView.vue?vue&type=template&id=624b1de0"
import script from "./TransformacionDigitalView.vue?vue&type=script&lang=js"
export * from "./TransformacionDigitalView.vue?vue&type=script&lang=js"

import exportComponent from "/home/xavi/Escriptori/rocabo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__